import React, { useState } from 'react';
import { Turl } from './tUrl.js'
import './css/emailVerificationFlow.css';
import { t } from 'ttag';

const tg = window.Telegram ? window.Telegram.WebApp : null;

const sendCodeToEmail = async (email) => {
  const _userData = tg ? tg.initData : null;
  let userData = { initData: _userData, email: email }

  const response = await fetch(Turl + '/api/send-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });
  return response.json();
};


const verifyCode = async (email, code) => {
  const _userData = tg ? tg.initData : null;
  let userData = { initData: _userData, email: email, code: code }

  const response = await fetch(Turl + '/api/verify-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });
  return response.json();
};

const EmailVerificationFlow = () => {
  const [step, setStep] = useState('enter_email'); // 'enter_email', 'enter_code', 'confirmed'
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const response = await sendCodeToEmail(email);

    setIsLoading(false);
    if (response.success) {
      setStep('enter_code');
    } else {
      setError(response.message || 'Не удалось отправить код. Попробуйте снова.');
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const response = await verifyCode(email, code);

    setIsLoading(false);
    if (response.success) {
      setStep('confirmed');
      setTimeout(() => {
        window.location.reload();
      }, 1000); // 1000 миллисекунд = 1 секунда
    } else {
      setError(response.message || 'Произошла ошибка.');
    }
  };

  // --- Рендеринг в зависимости от текущего шага ---

  if (step === 'confirmed') {
    return (
      <div className="Email-block" >
        <div >
          <h2 style={{ color: '#4cdf4c' }}>✓ Successfully!</h2>
          <p>Your email <strong>{email}</strong> was successfully confirmed.</p>
        </div>
      </div>
    );
  }

  if (step === 'enter_code') {
    return (
      <div className="Email-block" >
        <h2>Email Confirmation</h2>
        <p>We have sent a confirmation code to <strong>{email}</strong>. Please enter it below.</p>
        <form onSubmit={handleCodeSubmit}>
          <div className='email-enter'>
            <label htmlFor="code">Verification code:</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="123456"
              required
              disabled={isLoading}
              style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }}
            />
          </div>
          <div className='email-enter'>
            <button type="submit" disabled={isLoading || code.length < 6}>
              {isLoading ? 'Проверка...' : 'Confirm'}
            </button>
            {error && <p style={{ color: 'red', margin: '0' }}>{error}</p>}
            <button type="button" onClick={() => { setStep('enter_email'); setError(''); }} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', textAlign: 'left', padding: 0, marginTop: '10px', textDecoration: 'underline' }}>
              Change email
            </button>
          </div>
        </form>
      </div>
    );
  }

  return ( // step === 'enter_email'
    <div className="Email-block" >
      <h2>Enter your email</h2>
      <p>We will send a confirmation code to it.</p>
      <form onSubmit={handleEmailSubmit} >
        <div className='email-enter'>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.email@example.com"
            required
            disabled={isLoading}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }}
          />
        </div>
        <div className='email-enter'>
          <button type="submit" disabled={isLoading || !email} >
            {isLoading ? 'Sending...' : 'Send code'}
          </button>
        </div>
        {error && <p style={{ color: 'red', margin: '0' }}>{error}</p>}
      </form>
    </div>
  );
};

export { EmailVerificationFlow };